'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 0;\n  border: 0;\n  position: absolute;\n  top: ', ';\n  right: ', ';\n  z-index: 10;\n  display: block;\n  &:hover,\n  &:focus {\n    background-color: transparent;\n  }\n  svg {\n    transition: transform 0.3s ease;\n  }\n'], ['\n  padding: 0;\n  border: 0;\n  position: absolute;\n  top: ', ';\n  right: ', ';\n  z-index: 10;\n  display: block;\n  &:hover,\n  &:focus {\n    background-color: transparent;\n  }\n  svg {\n    transition: transform 0.3s ease;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 0;\n  padding: 0;\n'], ['\n  margin: 0;\n  padding: 0;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  transition: ', ';\n  font-weight: 300;\n  color: ', ';\n  /* display: none; */\n  opacity: 0;\n  &:hover {\n    color: ', ';\n  }\n  border-left: 4px solid\n    ', ';\n  padding-left: ', ';\n'], ['\n  transition: ', ';\n  font-weight: 300;\n  color: ', ';\n  /* display: none; */\n  opacity: 0;\n  &:hover {\n    color: ', ';\n  }\n  border-left: 4px solid\n    ', ';\n  padding-left: ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  left: ', ';\n  top: 50%;\n  svg path {\n    transition: fill 0.3s ease;\n  }\n'], ['\n  position: absolute;\n  left: ', ';\n  top: 50%;\n  svg path {\n    transition: fill 0.3s ease;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  transition: ', ';\n  font-weight: 300;\n  color: #2b2b2b;\n  opacity: 0;\n'], ['\n  transition: ', ';\n  font-weight: 300;\n  color: #2b2b2b;\n  opacity: 0;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  height: 100%;\n  width: ', ';\n  padding-top: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  height: 100%;\n  width: ', ';\n  padding-top: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  align-items: center;\n  color: ', ';\n  height: ', ';\n  position: relative;\n  padding-left: ', ';\n  transition: background-color 0.3s ease;\n  line-height: ', ';\n  /* &:hover {\n    color: ', ';\n  } */\n  ', ';\n'], ['\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  align-items: center;\n  color: ', ';\n  height: ', ';\n  position: relative;\n  padding-left: ', ';\n  transition: background-color 0.3s ease;\n  line-height: ', ';\n  /* &:hover {\n    color: ', ';\n  } */\n  ', ';\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n          border-left: 4px solid ', ';\n          /* background-color: ', '; */\n          ', ' {\n            svg path {\n              fill: ', ';\n            }\n          }\n        '], ['\n          border-left: 4px solid ', ';\n          /* background-color: ', '; */\n          ', ' {\n            svg path {\n              fill: ', ';\n            }\n          }\n        ']),
    _templateObject10 = _taggedTemplateLiteral(['\n          background-color: transparent;\n        '], ['\n          background-color: transparent;\n        ']),
    _templateObject11 = _taggedTemplateLiteral(['\n  list-style-type: none;\n  min-height: ', ';\n'], ['\n  list-style-type: none;\n  min-height: ', ';\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  font-size: ', ';\n  margin: ', ' 0 ', ';\n  ', ' {\n    border-bottom: 0;\n    margin-bottom: ', ';\n    min-height: inherit;\n  }\n  ', ' {\n    height: auto;\n    padding-left: ', ';\n    color: ', ';\n    &:hover {\n      background-color: transparent;\n      color: ', ';\n    }\n  }\n'], ['\n  font-size: ', ';\n  margin: ', ' 0 ', ';\n  ', ' {\n    border-bottom: 0;\n    margin-bottom: ', ';\n    min-height: inherit;\n  }\n  ', ' {\n    height: auto;\n    padding-left: ', ';\n    color: ', ';\n    &:hover {\n      background-color: transparent;\n      color: ', ';\n    }\n  }\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  width: ', ';\n  transition: width 0.3s ease;\n  background-color: #d2d2d2;\n  height: ', ';\n  position: relative;\n  z-index: 5;\n  box-shadow: 0 ', ' ', ' 0 rgba(0, 0, 0, 0.16);\n  /* border-right: ', ' solid ', '; */\n  ', ';\n'], ['\n  width: ', ';\n  transition: width 0.3s ease;\n  background-color: #d2d2d2;\n  height: ', ';\n  position: relative;\n  z-index: 5;\n  box-shadow: 0 ', ' ', ' 0 rgba(0, 0, 0, 0.16);\n  /* border-right: ', ' solid ', '; */\n  ', ';\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n          ', ' {\n            svg {\n              transform: rotate(180deg);\n            }\n          }\n          ', ' {\n            &:hover {\n              ', ' {\n                svg path {\n                  fill: ', ';\n                }\n              }\n            }\n          }\n          ', ' {\n            left: ', ';\n            transform: translate(0, -50%);\n          }\n          ', ' {\n            /* display: block; */\n            transition: ', ';\n            opacity: 1;\n            text-align: start;\n          }\n          ', ' {\n            display: block;\n            transition: ', ';\n            opacity: 1;\n          }\n        '], ['\n          ', ' {\n            svg {\n              transform: rotate(180deg);\n            }\n          }\n          ', ' {\n            &:hover {\n              ', ' {\n                svg path {\n                  fill: ', ';\n                }\n              }\n            }\n          }\n          ', ' {\n            left: ', ';\n            transform: translate(0, -50%);\n          }\n          ', ' {\n            /* display: block; */\n            transition: ', ';\n            opacity: 1;\n            text-align: start;\n          }\n          ', ' {\n            display: block;\n            transition: ', ';\n            opacity: 1;\n          }\n        ']),
    _templateObject15 = _taggedTemplateLiteral(['\n          ', ' {\n            svg {\n              transform: rotate(360deg);\n            }\n          }\n          ', ' {\n            &:hover {\n              svg path {\n                fill: ', ';\n              }\n            }\n          }\n          ', ' {\n            left: 50%;\n            transform: translate(-50%, -50%);\n          }\n        '], ['\n          ', ' {\n            svg {\n              transform: rotate(360deg);\n            }\n          }\n          ', ' {\n            &:hover {\n              svg path {\n                fill: ', ';\n              }\n            }\n          }\n          ', ' {\n            left: 50%;\n            transform: translate(-50%, -50%);\n          }\n        ']),
    _templateObject16 = _taggedTemplateLiteral(['\n  /* right: -190px; */\n  background: #b5b3b3;\n  ', ' {\n    right: 10px;\n    display: flex;\n    justify-content: flex-end;\n  }\n'], ['\n  /* right: -190px; */\n  background: #b5b3b3;\n  ', ' {\n    right: 10px;\n    display: flex;\n    justify-content: flex-end;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _polished = require('polished');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var OpenerButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject2, (0, _polished.rem)(5), (0, _polished.rem)(8));

var ListWrapper = _styledComponents2.default.ul(_templateObject3);

var Text = _styledComponents2.default.span(_templateObject4, function (_ref) {
  var isMenuOpen = _ref.isMenuOpen;
  return isMenuOpen ? 'opacity 0.9s ease' : 'none';
}, function (_ref2) {
  var selected = _ref2.selected,
      theme = _ref2.theme;
  return selected ? theme.color.primary : '#2b2b2b';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.primary;
}, function (_ref4) {
  var theme = _ref4.theme,
      isSubOpened = _ref4.isSubOpened;
  return isSubOpened ? theme.color.primary : 'transparent';
}, (0, _polished.rem)(8));

var SectionIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject5, (0, _polished.rem)(-10));

var ElapseIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject6, function (_ref5) {
  var isMenuOpen = _ref5.isMenuOpen;
  return isMenuOpen ? 'opacity 0.9s ease' : 'none';
});

var ElapseIconWrapper = _styledComponents2.default.div(_templateObject7, (0, _polished.rem)(48), (0, _polished.rem)(3));

var ActionLink = _styledComponents2.default.a(_templateObject8, function (_ref6) {
  var theme = _ref6.theme;
  return theme.color.textColor;
}, (0, _polished.rem)(55), (0, _polished.rem)(50), function (_ref7) {
  var theme = _ref7.theme;
  return theme.font.lineHeight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.color.primary;
}, function (_ref9) {
  var isSubOpened = _ref9.isSubOpened,
      theme = _ref9.theme;
  return isSubOpened ? (0, _styledComponents.css)(_templateObject9, theme.color.primary, theme.color.primaryBg, SectionIcon, theme.color.primary) : (0, _styledComponents.css)(_templateObject10);
});

var List = _styledComponents2.default.li(_templateObject11, (0, _polished.rem)(55));

//#bfd4bf
var SubListWrapper = (0, _styledComponents2.default)(ListWrapper)(_templateObject12, function (_ref10) {
  var theme = _ref10.theme;
  return theme.font.fontSizeXS;
}, (0, _polished.rem)(5), (0, _polished.rem)(15), List, (0, _polished.rem)(5), ActionLink, (0, _polished.rem)(50), function (_ref11) {
  var theme = _ref11.theme;
  return theme.mainMenu.submenuTextColor;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.color.primary;
});

var Overlay = _styledComponents2.default.aside(_templateObject13, function (_ref13) {
  var menuOpen = _ref13.menuOpen;
  return menuOpen ? '' + (0, _polished.rem)(250) : '' + (0, _polished.rem)(75);
}, function (_ref14) {
  var height = _ref14.height;
  return (0, _polished.rem)(height) || '100%';
}, (0, _polished.rem)(3), (0, _polished.rem)(5), (0, _polished.rem)(2), function (_ref15) {
  var theme = _ref15.theme;
  return theme.mainMenu.borderColor;
}, function (_ref16) {
  var menuOpen = _ref16.menuOpen;
  return menuOpen ? (0, _styledComponents.css)(_templateObject14, OpenerButton, ActionLink, SectionIcon, function (_ref17) {
    var theme = _ref17.theme;
    return theme.color.primary;
  }, SectionIcon, (0, _polished.rem)(20), Text, function (_ref18) {
    var isMenuOpen = _ref18.isMenuOpen;
    return !isMenuOpen ? 'opacity 0.9s ease' : 'none';
  }, ElapseIcon, function (_ref19) {
    var isMenuOpen = _ref19.isMenuOpen;
    return !isMenuOpen ? 'opacity 0.9s ease' : 'none';
  }) : (0, _styledComponents.css)(_templateObject15, OpenerButton, ActionLink, function (_ref20) {
    var theme = _ref20.theme;
    return theme.color.danger;
  }, SectionIcon);
});

var MenuOpenWrapper = (0, _styledComponents2.default)(ActionLink)(_templateObject16, SectionIcon);

var SidebarMenu = function (_Component) {
  _inherits(SidebarMenu, _Component);

  function SidebarMenu(props) {
    _classCallCheck(this, SidebarMenu);

    var _this = _possibleConstructorReturn(this, (SidebarMenu.__proto__ || Object.getPrototypeOf(SidebarMenu)).call(this, props));

    _this.handleToggleMenu = function () {
      var activeSectionId = _this.state.activeSectionId;

      _this.setState(function (prevState) {
        return { menuOpen: !prevState.menuOpen };
      });
      if (activeSectionId !== null) {
        _this.setState({
          // activeSectionId: null,
          // activeSubmenu: false
        });
      }

      _this.props.onMenuOpen(!_this.state.menuOpen);
    };

    _this.handleOpenSubMenu = function (section) {
      var _this$state = _this.state,
          activeSectionId = _this$state.activeSectionId,
          menuOpen = _this$state.menuOpen;

      if (activeSectionId === section._id && menuOpen === true) {
        _this.setState({
          activeSectionId: null,
          activeSubmenu: false,
          menuOpen: menuOpen || section.sections
        });
      } else {
        _this.setState({
          activeSectionId: section._id,
          activeSubmenu: true,
          menuOpen: menuOpen || section.sections
        });
      }

      if (section.url !== null) {
        _this.props.onClickLink(section);
      } else if (!menuOpen) {
        _this.props.onMenuOpen(!_this.state.menuOpen);
      }
    };

    _this.itemRenderer = function (section, idx, level) {
      var _this$state2 = _this.state,
          activeSectionId = _this$state2.activeSectionId,
          activeSubmenu = _this$state2.activeSubmenu,
          menuOpen = _this$state2.menuOpen;

      return _react2.default.createElement(
        List,
        { key: section._id },
        _react2.default.createElement(
          ActionLink,
          {
            isSubOpened: (section._id === activeSectionId || section.sections && section.sections.find(function (s) {
              return s._id === activeSectionId;
            })) && activeSubmenu && level === 1,
            onClick: function onClick() {
              _this.handleOpenSubMenu(section);
            }
          },
          level === 1 && _react2.default.createElement(SectionIcon, {
            size: 'm',
            name: section.icon,
            onClick: _this.handleOpenMenu
          }),
          _react2.default.createElement(
            Text,
            {
              style: {
                marginBottom: level > 1 && (0, _polished.rem)(4)
              },
              isMenuOpen: _this.state.menuOpen,
              isSubOpened: section._id === activeSectionId && activeSubmenu && !section.sections && level > 1
            },
            section.name
          ),
          section.sections && _react2.default.createElement(
            ElapseIconWrapper,
            null,
            _react2.default.createElement(ElapseIcon, {
              isMenuOpen: _this.state.menuOpen,
              name: section._id === activeSectionId ? 'expand_less' : 'expand_more',
              color: '#2b2b2b',
              size: 'l'
            })
          )
        ),
        (section._id === activeSectionId || section.sections && section.sections.find(function (s) {
          return s._id === activeSectionId;
        })) && activeSubmenu && menuOpen && _react2.default.createElement(
          SubListWrapper,
          null,
          section.sections && section.sections.map(function (item) {
            return _this.itemRenderer(item, idx, level + 1);
          })
        )
      );
    };

    _this.state = {
      menuOpen: false,
      activeSubmenu: false,
      activeSectionId: null
    };
    return _this;
  }

  _createClass(SidebarMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          actualPathName = _props.actualPathName,
          sections = _props.sections,
          menuState = _props.menuState;


      if (menuState === false || menuState === true) {
        this.setState({
          menuOpen: menuState
        });
      }

      if (actualPathName && sections) {
        var activeSection = sections.find(function (s) {
          return actualPathName.includes(s.url) || s.sections && s.sections.find(function (us) {
            return actualPathName.includes(us.url);
          });
        });
        if (activeSection) {
          if (!activeSection.sections && activeSection) {
            this.setState({
              activeSectionId: activeSection._id,
              activeSubmenu: true
            });
          } else {
            var activeUnderSection = activeSection.sections.find(function (s) {
              return actualPathName.includes(s.url);
            });

            if (activeUnderSection && activeUnderSection._id) {
              this.setState({
                activeSectionId: activeUnderSection && activeUnderSection._id,
                activeSubmenu: true
              });
            }
          }
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          actualPathName = _props2.actualPathName,
          sections = _props2.sections;


      if (nextProps.menuState === false || nextProps.menuState === true && nextProps.menuOpen !== this.props.menuState) {
        this.setState({
          menuOpen: nextProps.menuState
        });
      }

      if (actualPathName && sections && this.props.actualPathName !== nextProps.actualPathName) {
        var activeSection = sections.find(function (s) {
          return nextProps.actualPathName.includes(s.url) || s.sections && s.sections.find(function (us) {
            return nextProps.actualPathName.includes(us.url);
          });
        });

        if (activeSection) {
          if (!activeSection.sections && activeSection) {
            this.setState({
              activeSectionId: activeSection._id,
              activeSubmenu: true
            });
          } else {
            var activeUnderSection = activeSection.sections.find(function (s) {
              return nextProps.actualPathName.includes(s.url);
            });

            if (activeUnderSection && activeUnderSection._id) {
              this.setState({
                activeSectionId: activeUnderSection && activeUnderSection._id,
                activeSubmenu: true
              });
            }
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var sections = this.props.sections;


      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
          Overlay,
          { menuOpen: this.state.menuOpen, height: window.innerHeight },
          _react2.default.createElement(
            MenuOpenWrapper,
            { onClick: this.handleToggleMenu },
            _react2.default.createElement(SectionIcon, {
              size: 'xl',
              name: this.state.menuOpen ? 'menu_close1' : 'dehaze',
              onClick: this.handleToggleMenu
            })
          ),
          _react2.default.createElement(
            ListWrapper,
            null,
            sections.map(function (item, idx) {
              return _this2.itemRenderer(item, idx, 1);
            })
          )
        )
      );
    }
  }]);

  return SidebarMenu;
}(_react.Component);

SidebarMenu.propTypes = {
  sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    icon: _propTypes2.default.string,
    name: _propTypes2.default.string,
    id: _propTypes2.default.string,
    url: _propTypes2.default.string
  }).isRequired).isRequired,
  actualPathName: _propTypes2.default.string,
  onClickLink: _propTypes2.default.func.isRequired,
  onMenuOpen: _propTypes2.default.func.isRequired,
  menuState: _propTypes2.default.bool
};

SidebarMenu.defaultProps = {
  actualPathName: null,
  menuState: null
};

exports.default = SidebarMenu;
SidebarMenu.__docgenInfo = [{
  'description': '',
  'displayName': 'SidebarMenu',
  'methods': [{
    'name': 'handleToggleMenu',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'handleOpenSubMenu',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'section',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'itemRenderer',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'section',
      'type': null
    }, {
      'name': 'idx',
      'type': null
    }, {
      'name': 'level',
      'type': null
    }],
    'returns': null
  }],
  'props': {
    'sections': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'shape',
          'value': {
            'icon': {
              'name': 'string',
              'required': false
            },
            'name': {
              'name': 'string',
              'required': false
            },
            'id': {
              'name': 'string',
              'required': false
            },
            'url': {
              'name': 'string',
              'required': false
            }
          }
        }
      },
      'required': true,
      'description': ''
    },
    'actualPathName': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'onClickLink': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'onMenuOpen': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'menuState': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/SidebarMenu/index.js'] = {
    name: 'SidebarMenu',
    docgenInfo: SidebarMenu.__docgenInfo,
    path: 'src/SidebarMenu/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/SidebarMenu/index.js
// module id = 322
// module chunks = 1